<template>
  <v-dialog v-model="show" width="500px">
    <v-card>
      <v-container>
        <v-card-title>
          <v-col cols="12">
            <label>Platform</label>
            <v-autocomplete
              v-model="platformData"
              :items="platformList"
              clearable
              outlined
              label="choose platforms"
              item-text="platform_name"
              color="blue-grey lighten-2"
              item-value="id"
              multiple
            >
              <template v-slot:selection="data">
                <v-chip v-bind="data.attrs" :input-value="data.selected">
                  {{ data.item.platform_name }}
                </v-chip>
              </template>
            </v-autocomplete>
          </v-col>
        </v-card-title>
        <v-card-actions>
          <v-btn rounded color="info" @click="addPlatform">Insert</v-btn>
          <v-btn rounded color="secondary" @click="clearPlatform">Cancel</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions} from "vuex";
import DEFAULT_CONSTANTS from "@/Utilites/constants";
export default {
  name: "ProjectPlatformAdd",
  props: ["platformAdd", "platformList", "selectedList"],
  data() {
    return {
      timeout: 3000,
      platformData: [],
    };
  },
  watch: {},
  computed: {
    show: {
      get() {
        return this.platformAdd;
      },
      set(show) {
        this.$emit("add-platform-model-update", show);
      },
    },
  },
  methods: {
    ...mapActions([
      "showLoadingProcess",
      "closeLoading",
      "CreateProjectPlatform",
      "showSnackBar",
      "closeSnackBar",
    ]),
    async addPlatform() {
      await this.showLoadingProcess();
      try {
        const value = {
          project_id: this.$route.query.project_id,
          platform_id: this.platformData,
        };
        await this.CreateProjectPlatform(value);
        await this.closeLoading();
        this.clearPlatform();
        await this.showSnackBar({
          text: `Platforms has been added to Project`,
          color: DEFAULT_CONSTANTS.success,
        });
        setTimeout(async () => {
          await this.closeSnackBar();
        }, DEFAULT_CONSTANTS.timeout);
      } catch (err) {
        await this.closeLoading();
        this.clearPlatform();
        await this.showSnackBar({
          text: "Platform Insert Failed",
          color: DEFAULT_CONSTANTS.error,
        });
        setTimeout(async () => {
          await this.closeSnackBar();
        }, DEFAULT_CONSTANTS.timeout);
      }
    },
    clearPlatform() {
      this.platformData = [];
      this.show = false;
    },
  },
};
</script>

<style scoped></style>
